export default __webpack_public_path__ + "static/media/jingyinisland.ddb24092.png";